import $ from 'jquery'
import { setupApp } from '@/common/setup-app/setup-app.js'

import '../configuration/spark'
import '../configuration/axios'
import '../configuration/sweetalert'

import '../../css/theme-nexsas.css'

window.$ = window.jQuery = $

setupApp()
